import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_simple_event.js";
//#region src/bite_log_simple_event_helper.ts
var bite_log_simple_event_helper_exports = /* @__PURE__ */ __exportAll({ stringFromEnum: () => stringFromEnum });
function stringFromEnum(event) {
	switch (event) {
		case -1: return "unrecognized";
		case 0: return "simple status ok";
	}
}
//#endregion
export { bite_log_simple_event_helper_exports, stringFromEnum };

//# sourceMappingURL=bite_log_simple_event_helper.js.map